// components/IBANInput.jsx
import { useState } from 'react';
import { isValidIBAN, electronicFormatIBAN } from 'ibantools';

export default function IBANInput({ value, onChange, className = '' }) {
  const [validation, setValidation] = useState({ valid: true, message: '' });

  const handleChange = (e) => {
    const formatted = electronicFormatIBAN(e.target.value);
    onChange(formatted ?? e.target.value);
    setValidation({ valid: true, message: '' });
  };

  const handleBlur = (e) => {
    const formatted = electronicFormatIBAN(e.target.value);
    const empty = !e.target.value.trim();

    if (empty) {
      setValidation({ valid: true, message: '' });
    } else if (!formatted || !isValidIBAN(formatted)) {
      setValidation({ valid: false, message: 'Ongeldig IBAN' });
    } else {
      setValidation({ valid: true, message: '' });
    }
  };

  return (
    <div className={`col mb-3 ${className}`}>
      <label>IBAN</label>
      <input
        className={`form-control ${validation.valid ? '' : 'is-invalid'}`}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder="IBAN"
      />
      {!validation.valid && (
        <div className="invalid-feedback">{validation.message}</div>
      )}
    </div>
  );
}